import MultiCompressor from 'effects/MultiCompressor.js';
import Tone from 'tone';

class MultibandCompressor extends MultiCompressor {
    constructor(sequencerEngine) {
        super('Multiband Compressor', () => new Tone.MultibandCompressor(), sequencerEngine); 

        this.setCompressors({
            LOW: this.effectNode.low,
            MID: this.effectNode.mid,
            HIGH: this.effectNode.high
        });
    }

    dispose() {
        super.dispose();
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new MultibandCompressor(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default MultibandCompressor;
